import * as React from "react";
import { cn } from "../../utils/cn";

export interface EmptyStateProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
}

const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ className, icon, title, description, action, ...props }, ref) => (
    <div
      ref={ref}
      className={cn("flex flex-col items-center justify-center gap-4 py-20 text-center", className)}
      {...props}
    >
      {icon && (
        <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-surface-container text-surface-on-variant">
          {icon}
        </div>
      )}
      <div className="flex flex-col gap-1">
        <h3 className="font-headline font-bold text-surface-on">{title}</h3>
        {description && <p className="text-sm text-surface-on-variant max-w-sm">{description}</p>}
      </div>
      {action && <div className="mt-2">{action}</div>}
    </div>
  ),
);
EmptyState.displayName = "EmptyState";

export { EmptyState };
